<template>
  <div class="w-full">
    <div class="topWrapper primaryFont">
      <h1>ESCRITORIO</h1>
    </div>
    <div class="main-container">
      <div class="left-panel">
        <h2 class="panel-title">Por solicitud de estado</h2>
        <div class="grid-cards">
          <StatsRadialBasic
            v-if="!loadingJudicial"
            v-for="(item, index) in totalsTypesStates"
            :key="index"
            :title="item.Nombre"
            :series="[item.total]"
            :labels="['Total']"
            :titleSize="'18px'"
            :loading="isLoadingItem(item.TipoEstadoSolicitudID)"
            @reload="fetchEstadisticasByID(item.TipoEstadoSolicitudID)"
          />
        </div>
      </div>
      <div class="right-panel">
        <StatsBar
          style="width: 700px"
          title="Depósito por categoría"
          :series="seriesData"
          :categories="categoriesLabels"
          :loading="loadingJudicial"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useEstadisticasJudicialStore } from "@/store/Pinia/useEstadisticasJudicialStore";
import StatsBar from "@/components/Dashboard/StatsBar.vue";
import StatsRadialBasic from "@/components/Dashboard/StatsRadialBasic.vue";
import { storeToRefs } from "pinia";

const estadisticasJudicialStore = useEstadisticasJudicialStore();
const {
  totalsTypesStates,
  loadingJudicial,
  categoriesLabels,
  seriesData,
  fetchEstadisticasByID,
  isLoadingItem,
} = storeToRefs(estadisticasJudicialStore);

onMounted(async () => {
  await estadisticasJudicialStore.fetchEstadisticas();
});
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;600&display=swap");

.topWrapper {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: start;
  margin-top: 20px;
}

.topWrapper h1 {
  font-weight: 700;
  margin: 0;
}

.main-container {
  margin-top: 1rem;
  display: flex;
  gap: 2rem;
  font-family: "IBM Plex Sans";
}

@media (max-width: 1280px) {
  .main-container {
    flex-direction: column;
    justify-content: center;
  }
  .right-panel {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .grid-cards {
    justify-content: center;
  }
}

.left-panel {
  flex: 1;
}

.right-panel {
  flex: 1;
}

.panel-title {
  margin: 0;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 500;
  color: #000000;
}

.grid-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
}
</style>
